export default __webpack_public_path__ + "static/media/error.34d32bfde17768cf3da40926e7da282c.svg";